export default __webpack_public_path__ + "static/media/checkMark.eba5d4e3.svg";